export const AppConfigurationKeys = {
    AllowedEmailDomain: 'AllowedEmailDomain',
}